import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'app/rootReducer'
import './styles.scss'
import GoBackHeader from 'components/organisms/GoBackHeader'
import SimpleCardWithIcon from 'components/atoms/SimpleCardWithIcon'
import { Button } from 'react-bootstrap'
import { getContactTypeDescription } from 'share/domain/account'

interface Props {
  nextPage(page: string): void
}

const UserProfileReadOnly = (props: Props): JSX.Element => {
  const { nextPage } = props
  const authentication = useSelector((state: RootState) => state.authentication)

  const onSubmit = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ): Promise<void> => {
    e.preventDefault()

    nextPage('edit')
  }

  return (
    <React.Fragment>
      <GoBackHeader text='My Profile' />
      <div
        className='user-profile-read-only-container mb-0 mt-4 mt-lg-5'
        id='user-profile-read-only'
      >
        <SimpleCardWithIcon
          title='Name'
          description={`${authentication.account?.givenName} ${authentication.account?.familyName}`}
          icon='account'
        />
        <SimpleCardWithIcon
          title='Home Phone'
          description={authentication.account?.homePhone}
          icon='phone'
        />
        <SimpleCardWithIcon
          title='Mobile Phone'
          description={authentication.account?.mobilePhone}
          icon='phone'
        />
        <SimpleCardWithIcon
          title='Work Phone'
          description={authentication.account?.workPhone}
          icon='phone'
        />
        <SimpleCardWithIcon
          title='Email Address (User ID)'
          description={authentication.account?.emailAddress}
          icon='email'
        />
        <SimpleCardWithIcon
          title='Mailing Address'
          description={
            <>
              <p>{authentication.account?.street}</p>
              <p>
                {authentication.account?.city}, {authentication.account?.state}{' '}
                {authentication.account?.zip}
              </p>
            </>
          }
          icon='home'
        />
        <SimpleCardWithIcon
          title='Password'
          description='***********'
          icon='lock'
        />
        <SimpleCardWithIcon
          title='Send Notifications To'
          description={getContactTypeDescription(
            authentication.account?.contactType
          )}
          icon='bell'
        />
        <Button onClick={onSubmit}>Edit Profile</Button>
      </div>
    </React.Fragment>
  )
}

export default UserProfileReadOnly
